import { useEffect, useState } from "react";

// Shows 1 Oct – 1 Nov. Small pumpkin beside the greeting, a light cobweb in the banner corner and one spider that
// drops on its thread and crawls across the welcome text every ~20s. Respects prefers-reduced-motion (static only).
export const isHalloweenSeason = (d = new Date()) => (d.getMonth() === 9) || (d.getMonth() === 10 && d.getDate() === 1);

export function HalloweenPumpkin({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={`inline-block w-9 h-9 sm:w-11 sm:h-11 align-middle hw-pumpkin ${className}`} aria-label="Halloween pumpkin" role="img" data-testid="halloween-pumpkin">
      <path d="M33 14c0-5 2-8 7-10" stroke="#5b7a2b" strokeWidth="4" strokeLinecap="round" fill="none" />
      <ellipse cx="32" cy="38" rx="26" ry="21" fill="#e8731a" />
      <ellipse cx="18" cy="38" rx="11" ry="20" fill="#d9640f" opacity=".7" />
      <ellipse cx="46" cy="38" rx="11" ry="20" fill="#d9640f" opacity=".7" />
      <ellipse cx="32" cy="38" rx="9" ry="21" fill="#f08a2e" opacity=".8" />
      <path d="M20 31l6 7h-12z" fill="#3a1d0a" />
      <path d="M44 31l6 7h-12z" fill="#3a1d0a" />
      <path d="M17 46q15 12 30 0l-4 6-4-3-4 4-4-4-4 4-4-3z" fill="#3a1d0a" />
    </svg>
  );
}

export function HalloweenCobweb() {
  const ring = (r) => `M0 0 L${r} 0 A${r} ${r} 0 0 1 ${(r * 0.866).toFixed(1)} ${(r * 0.5).toFixed(1)} A${r} ${r} 0 0 1 ${(r * 0.5).toFixed(1)} ${(r * 0.866).toFixed(1)} A${r} ${r} 0 0 1 0 ${r}`;
  return (
    <svg viewBox="0 0 120 120" className="pointer-events-none absolute -top-2 -right-2 w-24 h-24 sm:w-32 sm:h-32 text-slate-400/70 hw-cobweb" aria-hidden="true" data-testid="halloween-cobweb">
      <g transform="translate(120 0) scale(-1 1)" fill="none" stroke="currentColor" strokeWidth="1">
        {[0, 30, 60, 90].map((a) => <line key={a} x1="0" y1="0" x2={(120 * Math.cos((a * Math.PI) / 180)).toFixed(1)} y2={(120 * Math.sin((a * Math.PI) / 180)).toFixed(1)} />)}
        {[22, 44, 66, 88, 110].map((r) => <path key={r} d={ring(r)} strokeDasharray={r > 60 ? "3 2" : undefined} />)}
      </g>
    </svg>
  );
}

export function HalloweenSpider({ intervalMs = 20000 }) {
  const [run, setRun] = useState(0);
  const [reduce, setReduce] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    setReduce(!!mq?.matches);
    if (mq?.matches) return undefined;
    const first = setTimeout(() => setRun(1), 2500);
    const id = setInterval(() => setRun((r) => r + 1), intervalMs);
    return () => { clearTimeout(first); clearInterval(id); };
  }, [intervalMs]);
  if (reduce) return null;
  return (
    <div key={run} className={`pointer-events-none absolute left-0 top-0 w-full h-full overflow-visible ${run ? "hw-spider-run" : "opacity-0"}`} aria-hidden="true" data-testid="halloween-spider">
      <div className="hw-spider-thread" />
      <svg viewBox="0 0 40 40" className="hw-spider-body w-7 h-7 text-slate-800">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="hw-legs">
          <path d="M14 18 L4 10 M14 22 L3 22 M14 26 L5 34 M26 18 L36 10 M26 22 L37 22 M26 26 L35 34" />
        </g>
        <ellipse cx="20" cy="24" rx="8" ry="9" fill="currentColor" />
        <circle cx="20" cy="13" r="5" fill="currentColor" />
        <circle cx="18" cy="12" r="1.2" fill="#f5b041" /><circle cx="22" cy="12" r="1.2" fill="#f5b041" />
      </svg>
    </div>
  );
}
